import { useEffect, useState } from "react";
import { IInputValidationItemController, IInputValidationItemProps, IInputValidatorItem } from "./interfaces/InputValidationInterfaces";
import { t } from "i18next";
import { EInputValidationResultType } from "./enums/InputValidationEnums";
import { GobalInputValidationEvent } from "./events/GobalInputValidationEvent";

export interface IInputValidationProps {
  items: IInputValidatorItem[];
  itemProps: IInputValidationItemProps;
  itemController: IInputValidationItemController;
  onMount?: () => void;
}

export interface IInputValidationControllerReturn {
  //states
  message: string | undefined;
  validResultType: EInputValidationResultType;
  isVisible: boolean;
  
  //functions
  strValidationIsVisible: (str?: string, displayMsg?: boolean) => EInputValidationResultType;
  strValidationNotVisible: (str?: string) => EInputValidationResultType;
  validate:(props: IValidateProps) => void;
}

interface IValidateProps {
  //ivc: IInputValidationControllerReturn | null, 
  value?: string | null, 
  //c: IInputValidationItemController,
  //props: IInputValidationItemProps,
  ignoreBlur?: boolean
}


export const InputValidatorController = (props: IInputValidationProps): IInputValidationControllerReturn => { 

  const tag = "InputValidatorController";


  const [ignoreBlur, setIgnoreBlur] = useState<boolean>(false); 
  const [isVisible, setIsVisible] = useState<boolean>(false); 
  const [validResultType, setValidResultType] = useState<EInputValidationResultType>(EInputValidationResultType._null);  
  const [message, setMessage] = useState<string>("");
  const setMsg = (msg: string) => {
    if(msg == message) return
    //console.log(tag + "message: "+msg)
    setMessage(t(msg))
  }

  const strValidationNotVisible = (str?: string | null): EInputValidationResultType => {
    //console.log(tag + " " + str);
    setIsVisible(false);
    return strValidation(str);
  }

  const strValidationIsVisible = (str?: string | null): EInputValidationResultType => {
    //console.log(tag + " " + str);
    setIsVisible(true);
    return strValidation(str);
  }


  const strValidation = (str?: string | null): EInputValidationResultType => {
    //console.log(tag + " " + str);
    //check if value is valid
    for(let idx: number = 0; idx <= props.items.length-1; idx++) {
      if(!props.items[idx].f(str)) {
        setValidResultType(props.items[idx].type);
        setMsg(props.items[idx].msgOnError);
        return props.items[idx].type;
      }
    }

    //value is valid
    setValidResultType(EInputValidationResultType.Valid);
    setMsg("");
    return EInputValidationResultType.Valid;
  }


  //init
  useEffect(() => {

    props.onMount?props.onMount(): null
    addSelfAsListener()
    
    return () => {
      removeSelfAsListener()
    }
  }, []);


  //#region listener
  const removeSelfAsListener = () => {
    window.removeEventListener('GobalInputValidationEvent',handleGlobalInputValidationEvent); 
  
  }
  
  const addSelfAsListener = () => {
    window.addEventListener('GobalInputValidationEvent',handleGlobalInputValidationEvent); 
  }


  const handleGlobalInputValidationEvent=(event: Event)=> {
    //console.log(tag + " handleDocumentsStoreCompleteUpdateEvent()")
    const e = event as GobalInputValidationEvent;
    setIgnoreBlur(true);
    setIsVisible(true);
  }

  //#endregion

  const validate = (propsIn: IValidateProps) => {

    //validate with no message
    if(!propsIn.ignoreBlur && !ignoreBlur) {
      if (!props.itemController.blur) { 
        props.itemProps.onInputValidation ?props.itemProps.onInputValidation(strValidationNotVisible(propsIn.value)) : {}; 
        return; 
      }
    }

    //include message
    props.itemProps.onInputValidation ? props.itemProps.onInputValidation(strValidationIsVisible(propsIn.value)) : {};
  }

  return {
    //state
    message, validResultType,
    isVisible,
    strValidationIsVisible,
    strValidationNotVisible,
    //functions
    validate
  }
}